<template>
  <ui-button color="primary" outlined @click="openDocument">
    {{ $t("message.posts.postsGuideBtn") }}
  </ui-button>
</template>

<script>
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "PostsGuideButton",
  methods: {
    openDocument() {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.POST_GUIDE_OPEN,
        page_name: this.$route.name
      });
      window
        .open(
          this.$i18n.locale === "pl"
            ? "/wpisy_poradnik.pdf"
            : "/posts_guide.pdf",
          "_blank"
        )
        .focus();
    }
  }
};
</script>
